import Router from 'next/router'

import excludeBlankKeys from '@/helpers/excludeBlankKeys'

function setPriceParam(name: string, value: number) {
  const { push, query: params } = Router
  const price = value > 0 ? value : null
  const query = excludeBlankKeys<string>({
    ...params,
    [name]: price,
    page: null,
  })

  push({ query }, undefined, { shallow: true })
}

export default setPriceParam
